/** 审核状态（帖子） */
export const auditStatusList = [
  {
    text: '审核中',
    value: 0,
  },
  {
    text: '已通过',
    value: 1,
  },
  {
    text: '未过审',
    value: 2,
  },
  {
    text: '待人工',
    value: 3,
  },
]

/** 举报内容类型 */
export const reportTypeList = [
  {
    text: '帖子',
    value: 1,
  },
  {
    text: '评论',
    value: 2,
  },
]

/** 身份类型 */
export const identityList = [
  {
    text: '粉丝',
    value: 0,
  },
  {
    text: '车主',
    value: 1,
  },
  {
    text: '管理员',
    value: 2,
  },
]

/** 称谓类型 */
export const appellationList = [
  {
    text: '先生',
    value: 1,
  },
  {
    text: '女士',
    value: 2,
  },
]

/** 举报内容处理状态 */
export const reportHandleStatusList = [
  {
    text: '已处理',
    value: 1,
  },
  {
    text: '待处理',
    value: 2,
  },
]

/** 举报内容处理状态 */
export const reportHandleResultStatusList = [
  {
    text: '已隐藏',
    value: 0,
  },
  {
    text: '已忽略',
    value: 1,
  },
  {
    text: '待处理',
    value: 2,
  },
]

/** 话题状态 */
export const topicState = [
  {
    text: '使用中',
    value: 0,
  },
  {
    text: '已禁用',
    value: 1,
  },
]

/** 话题标签 */
export const topicTag = [
  {
    text: '热',
    value: 'HOT',
  },
  {
    text: '新',
    value: 'NEW',
  },
  {
    text: '升',
    value: 'UPTREND',
  },
]

/** pgc帖子类型 */
export const postTypeList = [
  {
    text: '普通帖',
    value: 0,
  },
  {
    text: '活动贴',
    value: 1,
  },
  {
    text: '长文贴',
    value: 2,
  },
  {
    text: '文章贴',
    value: 4,
  },
]

/** pgc帖子类型 */
export const addPostTypeList = [
  {
    text: '普通帖',
    value: 0,
  },
  {
    text: '活动贴',
    value: 1,
  },
  {
    text: '长文贴',
    value: 2,
  },
  {
    text: '文章帖',
    value: 4,
  },
]

/** pgc帖子状态 */
export const postStatusList = [
  {
    text: '待提交',
    value: 0,
  },
  {
    text: '待审核',
    value: 1,
  },
  {
    text: '已通过',
    value: 2,
  },
  {
    text: '已发布',
    value: 3,
  },
  {
    text: '已拒绝',
    value: 4,
  },
]

export const campaignStatusList = [
  {
    text: '待提交',
    value: 0,
  },
  {
    text: '待审核',
    value: 1,
  },
  {
    text: '已通过',
    value: 2,
  },
  {
    text: '已发布',
    value: 3,
  },
  {
    text: '已拒绝',
    value: 4,
  },
  {
    text: '活动中',
    value: 5,
  },
  {
    text: '已结束',
    value: 6,
  },
]

/** pgc帖子可见地址 */
export const PostVisibleAddressList = [
  {
    text: '论坛',
    value: 1,
  },
  {
    text: '群组',
    value: 2,
  },
  {
    text: '群组&论坛',
    value: 3,
  },
]

/** OEM 用户类型 */
export const oemUserType = [
  {
    text: 'Admin',
    value: 1,
  },
  {
    text: 'User',
    value: 0,
  },
]

/** 抽奖发布状态 */
export const lotteryReleaseState = [
  {
    text: '待提交',
    value: 0,
  },
  {
    text: '待审核',
    value: 1,
  },
  {
    text: '已通过',
    value: 2,
  },
  {
    text: '已启用',
    value: 3,
  },
  {
    text: '已拒绝',
    value: 4,
  },
]

/** 抽奖使用状态 */
export const lotteryUserState = [
  {
    text: '未使用',
    value: 0,
  },
  {
    text: '使用中',
    value: 1,
  },
  {
    text: '已结束',
    value: 2,
  },
]

/** 奖品类型 */
export const prizeTypeList = [
  {
    text: '实物',
    value: 0,
  },
  {
    text: '虚拟',
    value: 1,
  },
  {
    text: '未中奖',
    value: 2,
  },
]
/** OEM 活动类型 */
export const campaignTypeList = [
  {
    text: '品牌推广',
    value: 0,
  },
  {
    text: '新车推荐',
    value: 1,
  },
]

/** OEM 活动对象 */
export const campaignTargetList = [
  {
    text: '车主',
    value: 1,
  },
  {
    text: '全体',
    value: 2,
  },
]

/** 是否 */
export const statusList = [
  {
    text: '否',
    value: 0,
  },
  {
    text: '是',
    value: 1,
  },
]

export const realIdentityList = [
  {
    text: '粉丝',
    value: 0,
  },
  {
    text: '车主',
    value: 1,
  },
]
/** 审核状态（报名） */
export const signUpAuditStatusList = [
  {
    text: '审核中',
    value: 0,
  },
  {
    text: '已通过',
    value: 1,
  },
  {
    text: '已拒绝',
    value: 2,
  },
]
/** 群组状态 */
export const tribeStatusList = [
  {
    text: '待提交',
    value: 0,
  },
  {
    text: '待审核',
    value: 1,
  },
  {
    text: '已通过',
    value: 2,
  },
  {
    text: '已拒绝',
    value: 3,
  },
  {
    text: '已启用',
    value: 4,
  },
]

/** 群组申请审核状态 */
export const tribeApplyStatus = [
  {
    text: '待处理',
    value: 0,
  },
  {
    text: '已通过',
    value: 1,
  },
  {
    text: '已拒绝',
    value: 2,
  },
]
/** 入群身份限制 */
export const joinTribeLimitList = [
  {
    text: '无',
    value: 0,
  },
  {
    text: '仅车主',
    value: 1,
  },
]

/** 通知送达状态 */
export const notificationSendState = [
  {
    text: '未送达',
    value: 0,
  },
  {
    text: '已送达',
    value: 1,
  },
]

/** 通知已读状态 */
export const notificationReadState = [
  {
    text: '未读',
    value: 0,
  },
  {
    text: '已读',
    value: 1,
  },
]

/** 通知类型 */
export const notificationType = [
  {
    text: '自由录入',
    value: 1,
  },
  {
    text: '消息模板',
    value: 2,
  },
]

export const banCauseList = [
  {
    text: '色情低俗',
    value: 1,
  },
  {
    text: '违法犯罪',
    value: 2,
  },
  {
    text: '政治敏感',
    value: 3,
  },
  {
    text: '违规营销',
    value: 4,
  },
  {
    text: '不实信息',
    value: 5,
  },
  {
    text: '垃圾广告',
    value: 6,
  },
  {
    text: '危害人身安全',
    value: 7,
  },
  {
    text: '侮辱谩骂他人',
    value: 8,
  },
  {
    text: '宗教迷信',
    value: 9,
  },
  {
    text: '未成年不良内容',
    value: 10,
  },
  {
    text: '内容引起不适',
    value: 11,
  },
  {
    text: '涉嫌低劣/作弊',
    value: 12,
  },
  {
    text: '侵犯隐私/名誉/肖像等权益',
    value: 13,
  },
  {
    text: '其他（补充输入）',
    value: 14,
  },
]

export const processingTimes = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '0-20次',
    value: 1,
  },
  {
    text: '21-50次',
    value: 2,
  },
  {
    text: '51-100次',
    value: 3,
  },
  {
    text: '101-300次',
    value: 4,
  },
  {
    text: '300次以上',
    value: 5,
  },
]

export const violationIdentity = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '普通用户',
    value: 0,
  },
  {
    text: '车主',
    value: 1,
  },
]

export const violationTypeList = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '动态',
    value: 1,
  },
  {
    text: '评论',
    value: 2,
  },
  {
    text: '头像同步违规',
    value: 3,
  },
  {
    text: '昵称同步违规',
    value: 4,
  },
]

export const violationContentType = [
  {
    text: '全部',
    value: 0,
  },
  {
    text: '文本',
    value: 1,
  },
  {
    text: '图片',
    value: 2,
  },
  {
    text: '文本&图片',
    value: 3,
  },
  {
    text: '视频',
    value: 4,
  },
  {
    text: '文本&视频',
    value: 5,
  },
]
export const violationContentNoAllType = [
  {
    text: '文本',
    value: 1,
  },
  {
    text: '图片',
    value: 2,
  },
  {
    text: '文本&图片',
    value: 3,
  },
  {
    text: '视频',
    value: 4,
  },
  {
    text: '文本&视频',
    value: 5,
  },
]

export const violationSourceList = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '自动',
    value: 1,
  },
  {
    text: '人工',
    value: 2,
  },
]

export const violationHandleStatus = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '待处理',
    value: 0,
  },
  {
    text: '已处理',
    value: 1,
  },
]

export const banTimesList = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '3天',
    value: 1,
  },
  {
    text: '7天',
    value: 2,
  },
  {
    text: '30天',
    value: 3,
  },
  {
    text: '永久',
    value: 4,
  },
]

export const banCauseQueryList = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '人身攻击',
    value: 0,
  },
  {
    text: '有害信息',
    value: 1,
  },
  {
    text: '不实信息',
    value: 2,
  },
  {
    text: '恐怖恶心',
    value: 3,
  },
  {
    text: '色情低俗',
    value: 4,
  },
  {
    text: '违法信息',
    value: 5,
  },
]

export const banStatusList = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '禁言中',
    value: 1,
  },
  {
    text: '已过期',
    value: 2,
  },
  {
    text: '已解禁',
    value: 3,
  },
]

export const downloadList = [
  {
    text: '全部',
    value: '',
  },
  {
    text: '活动列表',
    value: 1,
  },
  {
    text: '活动报名列表',
    value: 2,
  },
  {
    text: '活动中奖人列表',
    value: 3,
  },
  {
    text: 'PGC列表',
    value: 4,
  },
  {
    text: 'UGC列表',
    value: 5,
  },
  {
    text: '用户列表',
    value: 6,
  },
  {
    text: '群组列表',
    value: 7,
  },
  {
    text: '群组成员列表',
    value: 8,
  },
  {
    text: '违规管理列表',
    value: 9,
  },
  {
    text: '违规明细',
    value: 10,
  },
  {
    text: '违规处理记录',
    value: 11,
  },
  {
    text: '群组帖子',
    value: 12,
  },
  {
    text: '群组活动列表',
    value: 13,
  },
  {
    text: '群组申请列表',
    value: 14,
  },
  {
    text: '话题列表',
    value: 15,
  },
  {
    text: '话题帖子列表',
    value: 16,
  },
  {
    text: '话题活动列表',
    value: 17,
  },
  {
    text: '评论列表',
    value: 18,
  },
]

// pgc查询条件贴文附件
export const pgcMediaType = [
  {
    text: '无',
    value: 0,
  },
  {
    text: '图片',
    value: 1,
  },
  {
    text: '视频',
    value: 2,
  },
  {
    text: '图片和视频',
    value: 3,
  },
]

export const ugcPostType = [
  {
    text: '普通贴',
    value: 0,
  },
  {
    text: '活动贴',
    value: 1,
  },
  {
    text: '转发贴',
    value: 3,
  },
  {
    text: '文章贴',
    value: 4,
  },
]

export const videoViolationType = [
  {
    text: '文本',
    value: 0,
  },
  {
    text: '图片',
    value: 1,
  },
  {
    text: '封面图',
    value: 2,
  },
  {
    text: '帧截图',
    value: 3,
  },
  {
    text: '音频',
    value: 4,
  },
]

export const violationScope = [
  {
    text: '文本',
    value: 'TEXT',
  },
  {
    text: '图片/封面图',
    value: 'IMAGE',
  },
  {
    text: '视频',
    value: 'VIDEO',
  },
]
